<app-loading-screen-min [status]=false [session]=1></app-loading-screen-min>
<carousel (activeSlideChange)="log($event)" [interval]="false">
    <slide *ngFor="let item of this.banlist; let i = index">
        <div class="pyfcont">
            <div class="basicrow msidespad">
              <div class="b-title noline">
                <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                  <div class="tabcell">
                    Pagos y Facturas
                  </div>
                </div>

                <div class="autocont f-mgray roboto-m f-mini pull-right vcenter">
                  <div class="tabcell">
                    {{i+1}} de {{this.banlist.length}} cuentas
                  </div>
                </div>
              </div>
            </div>

            <div class="infolabel">
              <div class="autorow full-c-i f-reg f-black roboto-r pull-left m-top-u mob-le">
                <div class="tabcell">
                  N&uacute;mero de Cuenta  <span class="roboto-b"> {{item.account}}</span>
                </div>
              </div>

              <div class="autorow full-c-i f-reg f-black roboto-r pull-right m-top-u mob-pull">
                <div class="tabcell">
                  Fecha de factura <span class="roboto-b">{{this.billDateField}}</span>
                </div>
              </div>
            </div>

            <div class="basicrow">
              <div class="basicrow msidespad roboto-r m-top mbott f-reg f-black">
                <div class="device-i rpad">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="basicrow text-center f-black f-reg roboto-r">
                        <div class="basicrow m-top-u">
                          <span class="roboto-b">Ciclo de Facturación</span><br/>
                          <span class="roboto-b f-gray">
                              {{this.cycleDateField}} 
                          </span>
                        </div>

                        <div class="basicrow m-top-ii">
                            <div class="diasRestantes">
                                <span class="roboto-b f-gray">
                                    Quedan<br>
                                    {{this.diasciclo}}
                                </span>
                            </div>
                            <canvas id="idCanvas_{{i}}"class="canvas-a" width="225" height="225">su navegador no soportado canvas</canvas>
                          
                        </div>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="basicrow text-center f-black f-reg roboto-r">
                        <div class="basicrow m-top-u">
                              <span class="roboto-b">
                                  Su Factura Vence
                              </span><br>

                          <span class="f-black f-big roboto-b">
                              {{this.billDueDateField}}
                          </span>
                        </div>

                        <div class="basicrow m-top-u">
                          Cliente Claro desde<br>
                          <span class="roboto-b">
                            {{this.billDateField}}
                          </span>
                        </div>

                        <div class="basicrow m-top" *ngIf="this.statusPdf==true">
                          <a (click)="this.global.openPDF2(this.invoiceContent,this.billDate)" target="_blank" class="linkdefs">Descargar Factura PDF&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="device-i middle resumeanew">
                  <div class="basicrow roboto-r text-center f-reg">
                    <div class="basicrow m-top-u">
                      <span class="roboto-b">Balance Actual :</span>
                    </div>

                    <div class="basicrow rel m-top-u">
                      <img matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="Ahora puedes abonar hasta $99,999.99 Si la cantidad indica CR, significa que usted tiene crédito en su cuenta." class="q-t" width="100%" src="../../assets/images/tooltip1.png">
                      <input [(ngModel)]="this.amountPayable2" maxlength="10"  class="inp-f billmonto" (ngModelChange)="this.checkAmount()" [appOnlycoin]>
                    </div>

                    <div class="basicrow m-top">
                        <a  (click)="this.doPayment()"class="btns red vcenter"  [ngClass]="{'red': this.dopaymentmount,'gray':  !this.dopaymentmount}">
                          <span class="tabcell cursor">
                              Pagar Factura&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i> 
                          </span> 
                        </a>
                    </div>
                  </div>
                </div>
                <div class="paperless-container-paymentinvoices">
                  <app-paperless-box  [(currentBan)]="item.account" [(loadingData)]="loadingData[i]" [(email)]="this.email"></app-paperless-box>
                </div>
              </div>
            </div>
          </div>

    </slide>
  
  </carousel>
  